import React from "react";

export default function Report() {
  return <div>Report</div>;
}
